export default __webpack_public_path__ + "static/Kalam-Bold-b27e562fbc8c58393c0d287212d74a0e.woff";